String.prototype.turkishToUpper = function() {
  return this.replace(/ğ/g, 'Ğ')
    .replace(/ü/g, 'Ü')
    .replace(/ş/g, 'Ş')
    .replace(/ı/g, 'I')
    .replace(/i/g, 'İ')
    .replace(/ö/g, 'Ö')
    .replace(/ç/g, 'Ç')
    .toUpperCase();
}; //String.turkishUpperCase

String.prototype.turkishToLower = function() {
  return this.replace(/Ğ/g, 'ğ')
    .replace(/Ü/g, 'ü')
    .replace(/Ş/g, 'ş')
    .replace(/I/g, 'ı')
    .replace(/İ/g, 'i')
    .replace(/Ö/g, 'ö')
    .replace(/Ç/g, 'ç')
    .toLowerCase();
}; //String.turkishLowerCase

String.prototype.turkishCapitalize = function() {
  return this.charAt(0).turkishToUpper() + this.slice(1).turkishToLower()
}; //String.turkishCapitalize
String.prototype.turkishCapitalizeWords = function() {
  var a = this.split(' ');
  for (var i = 0; i < a.length; i++) a[i] = a[i].turkishCapitalize();
  return a.join(' ');
}; //String.turkishCapitalizeWords

String.prototype.slugify = function() {
  // var string = this;

  var string = this.replace(/ğ/g, 'Ğ')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/i/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/ /g, '-')
    .replace(/Ü/g, 'u')
    .replace(/Ş/g, 's')
    .replace(/I/g, 'i')
    .replace(/İ/g, 'i')
    .replace(/Ö/g, 'o')
    .replace(/Ç/g, 'c')
    .toLowerCase();

  string = string.replace(/[^a-zA-Z0-9-_]/g, '');
  return string.toLowerCase();
}

Date.prototype.formatDDMMYYYY = function() {
  return ("0" + this.getDate()).slice(-2) +
    "/" + ("0" + (this.getMonth() + 1)).slice(-2) +
    "/" + this.getFullYear();
}
